/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { TaskEvaluationRequestEvaluationAnyOf } from './taskEvaluationRequestEvaluationAnyOf';

export type TaskEvaluationRequestEvaluation = TaskEvaluationRequestEvaluationAnyOf | null;
